module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M12.96 32H5.908C4.794 32 4 31.106 4 30V18H1.042c-1.114 0-1.376-.632-.59-1.414l16.122-16a2.027 2.027 0 0 1 2.852 0l16.122 16c.786.782.522 1.414-.59 1.414H32v12c0 1.106-.794 2-1.908 2H23.04c-.56 0-1.04-.448-1.04-1v-8c0-.552-.42-1-.976-1h-6.048c-.556 0-.976.448-.976 1v8c0 .552-.48 1-1.04 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/house-1.js
// module id = 1174
// module chunks = 14